// ======================================================================
// File Name       : FunctionConstants
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const TOP = 'TOP';
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const SERVICE_LOGIN = 'SERVICE_LOGIN';

//企業向けお知らせ管理
export const ENTERPRISE_NOTIFICATION_LIST = 'ENTERPRISE_NOTIFICATION_LIST';
export const ENTERPRISE_NOTIFICATION_DETAIL = 'ENTERPRISE_NOTIFICATION_DETAIL';
export const ENTERPRISE_NOTIFICATION_EDIT = 'ENTERPRISE_NOTIFICATION_EDIT';
export const ENTERPRISE_NOTIFICATION_REGISTER = 'ENTERPRISE_NOTIFICATION_REGISTER';
export const ENTERPRISE_NOTIFICATION_IMPORT = 'ENTERPRISE_NOTIFICATION_IMPORT';

// 企業管理画面
export const ENTERPRISE_LIST = 'ENTERPRISE_LIST';
export const ENTERPRISE_DETAIL = 'ENTERPRISE_DETAIL';
export const ENTERPRISE_EDIT = 'ENTERPRISE_EDIT';
export const ENTERPRISE_REGISTER = 'ENTERPRISE_REGISTER';
export const ENTERPRISE_DELETE = 'ENTERPRISE_DELETE';
export const ENTERPRISE_IMPORT = 'ENTERPRISE_IMPORT';

// SuperUser管理画面

export const SUPERUSER_LIST = 'SUPERUSER_LIST';
export const SUPERUSER_DETAIL = 'SUPERUSER_DETAIL';
export const SUPERUSER_EDIT = 'SUPERUSER_EDIT';
export const SUPERUSER_REGISTER = 'SUPERUSER_REGISTER';
export const SUPERUSER_IMPORT = 'SUPERUSER_IMPORT';
// サービス管理画面

export const SERVICE_LIST = 'SERVICE_LIST';
export const SERVICE_DETAIL = 'SERVICE_DETAIL';
export const SERVICE_EDIT = 'SERVICE_EDIT';
export const SERVICE_REGISTER = 'SERVICE_REGISTER';
export const SERVICE_IMPORT = 'SERVICE_IMPORT';
export const SERVICE_NOTIFICATION_LIST = 'SERVICE_NOTIFICATION_LIST';
export const SERVICE_NOTIFICATION_DETAIL = 'SERVICE_NOTIFICATION_DETAIL';
export const SERVICE_NOTIFICATION_REGISTER = 'SERVICE_NOTIFICATION_REGISTER';
export const SERVICE_NOTIFICATION_EDIT = 'SERVICE_NOTIFICATION_EDIT';
export const SERVICE_NOTIFICATION_IMPORT = 'SERVICE_NOTIFICATION_IMPORT';
export const SERVICE_DETAIL_MENU_NONE = 'SERVICE_DETAIL_MENU_NONE';
// 権限ロール管理画面

export const AUTHORITY_LIST = 'AUTHORITY_LIST';
export const AUTHORITY_DETAIL = 'AUTHORITY_DETAIL';
export const AUTHORITY_EDIT = 'AUTHORITY_EDIT';
export const AUTHORITY_REGISTER = 'AUTHORITY_REGISTER';
export const AUTHORITY_IMPORT = 'AUTHORITY_IMPORT';
// ユーザー管理画面
export const USER_LIST = 'USER_LIST';
export const USER_DETAIL = 'USER_DETAIL';
export const USER_EDIT = 'USER_EDIT';
export const USER_REGISTER = 'USER_REGISTER';
export const USER_IMPORT = 'USER_IMPORT';
// ユーザーグループ管理画面
export const GROUP_LIST = 'GROUP_LIST';
export const GROUP_DETAIL = 'GROUP_DETAIL';
export const GROUP_EDIT = 'GROUP_EDIT';
export const GROUP_REGISTER = 'GROUP_REGISTER';
export const GROUP_DELETE = 'GROUP_DELETE';
export const GROUP_IMPORT = 'GROUP_IMPORT';
// コンテンツ配布先管理画面
export const CONTENT_DISTRIBUTION_LIST = 'CONTENT_DISTRIBUTION_LIST'; // コンテンツ配布先一覧
export const CONTENT_DISTRIBUTION_OFFER_LIST_DETAIL = 'CONTENT_DISTRIBUTION_OFFER_LIST_DETAIL';
export const CONTENT_DISTRIBUTION_OFFER_LIST_EDIT = 'CONTENT_DISTRIBUTION_OFFER_LIST_EDIT'; // 提供コンテンツ一覧
export const CONTENT_DISTRIBUTION_EDIT = 'CONTENT_DISTRIBUTION_EDIT';
export const CONTENT_DISTRIBUTION_USAGE_DETAIL = 'CONTENT_DISTRIBUTION_USAGE_DETAIL'; // 利用状況詳細
export const CONTENT_DISTRIBUTION_REGISTER = 'CONTENT_DISTRIBUTION_REGISTER';
export const CONTENT_DISTRIBUTION_IMPORT = 'CONTENT_DISTRIBUTION_IMPORT';
export const COURSE_DISTRIBUTION_IMPORT = 'COURSE_DISTRIBUTION_IMPORT';

// 外部コンテンツ管理画面
export const EXTERNAL_CONTENT_OFFER_LIST = 'EXTERNAL_CONTENT_OFFER_LIST'; // 提供元一覧
export const EXTERNAL_CONTENT_LIST = 'EXTERNAL_CONTENT_LIST';
export const EXTERNAL_CONTENT_EDIT = 'EXTERNAL_CONTENT_EDIT';
// コース管理画面
export const COURSE_LIST = 'COURSE_LIST';
export const COURSE_REGISTER = 'COURSE_REGISTER';
export const COURSE_DETAIL = 'COURSE_DETAIL';
export const COURSE_EDIT = 'COURSE_EDIT';
export const COURSE_IMPORT = 'COURSE_IMPORT';
export const COURSE_DELETE = 'COURSE_DELETE';
export const COURSE_THUMBNAIL_UPDATE = 'COURSE_THUMBNAIL_UPDATE';
export const COURSE_RESET_CONDITION = 'COURSE_RESET_CONDITION';
export const COURSE_SORT = 'COURSE_SORT';

export const BOX_REGSITER = 'COURSE_BOX_REGSITER';
export const BOX_DETAIL = 'COURSE_BOX_DETAIL';
export const BOX_EDIT = 'COURSE_BOX_EDIT';
export const BOX_DELETE = 'COURSE_BOX_DELETE';
export const BOX_SORT = 'BOX_SORT';

export const CONTENT_LINKING_DETAIL = 'CONTENT_LINKING_DETAIL';
export const CONTENT_LINKING_EDIT = 'CONTENT_LINKING_EDIT';
export const CONTENT_LINKING_REGISTER = 'CONTENT_LINKING_REGISTER';
export const CONTENT_LINKING_DELETE = 'CONTENT_LINKING_DELETE';
export const CONTENT_LINKING_SORT = 'CONTENT_LINKING_SORT';

// コンテンツ管理画面
export const CONTENT_LIST = 'CONTENT_LIST';
export const CONTENT_QUESTION_LIST = 'CONTENT_QUESTION_LIST';
export const CONTENT_QUESTION_DETAIL = 'CONTENT_QUESTION_DETAIL';
export const CONTENT_QUESTION_EDIT = 'CONTENT_QUESTION_EDIT';
export const CONTENT_QUESTION_REGISTER = 'CONTENT_QUESTION_REGISTER';
export const CONTENT_QUESTION_IMPORT = 'CONTENT_QUESTION_IMPORT';
export const CONTENT_QUESTION_ATTRIBUTE = 'CONTENT_QUESTION_ATTRIBUTE';
export const CONTENT_QUESTION_ATTRIBUTE_LIST = 'CONTENT_QUESTION_ATTRIBUTE_LIST';
export const CONTENT_QUESTION_PERSPECTIVE = 'CONTENT_QUESTION_PERSPECTIVE';
export const CONTENT_DRILL_LIST = 'CONTENT_DRILL_LIST';
export const CONTENT_DRILL_DETAIL = 'CONTENT_DRILL_DETAIL';
export const CONTENT_DRILL_EDIT = 'CONTENT_DRILL_EDIT';
export const CONTENT_DRILL_REGISTER = 'CONTENT_DRILL_REGISTER';
export const CONTENT_DRILL_IMPORT = 'CONTENT_DRILL_IMPORT';
export const CONTENT_DRILL_SKIN_LIST = 'CONTENT_DRILL_SKIN_LIST';
export const CONTENT_DRILL_SKIN_REGISTER = 'CONTENT_DRILL_SKIN_REGISTER';
export const CONTENT_DRILL_SKIN_EDIT = 'CONTENT_DRILL_SKIN_EDIT';
export const CONTENT_DRILL_SKIN_DETAIL = 'CONTENT_DRILL_SKIN_DETAIL';
export const CONTENT_DRILL_BUTTON_LABEL = 'CONTENT_DRILL_BUTTON_LABEL';
export const CONTENT_DRILL_CHARACTER = 'CONTENT_DRILL_CHARACTER';
export const CONTENT_DRILL_MESSAGE = 'CONTENT_DRILL_MESSAGE';
export const CONTENT_DRILL_NOTIFICATION_LIST = 'CONTENT_DRILL_NOTIFICATION_LIST'; // 通知メッセージ管理
export const CONTENT_DRILL_NOTIFICATION_REGISTER = 'CONTENT_DRILL_NOTIFICATION_REGISTER'; // 通知メッセージ管理
export const CONTENT_DRILL_NOTIFICATION_DETAIL = 'CONTENT_DRILL_NOTIFICATION_DETAIL';
export const CONTENT_DRILL_NOTIFICATION_EDIT = 'CONTENT_DRILL_NOTIFICATION_EDIT';
export const CONTENT_VIDEO = 'CONTENT_VIDEO';
export const CONTENT_VIDEO_LIST = 'CONTENT_VIDEO_LIST';
export const CONTENT_VIDEO_DETAIL = 'CONTENT_VIDEO_DETAIL';
export const CONTENT_VIDEO_EDIT = 'CONTENT_VIDEO_EDIT';
export const CONTENT_VIDEO_REGISTER = 'CONTENT_VIDEO_REGISTER';
export const CONTENT_VIDEO_IMPORT = 'CONTENT_VIDEO_IMPORT';
export const CONTENT_DOCUMENT_LIST = 'CONTENT_DOCUMENT_LIST';
export const CONTENT_DOCUMENT_DETAIL = 'CONTENT_DOCUMENT_DETAIL';
export const CONTENT_DOCUMENT_EDIT = 'CONTENT_DOCUMENT_EDIT';
export const CONTENT_DOCUMENT_REGISTER = 'CONTENT_DOCUMENT_REGISTER';
export const CONTENT_DOCUMENT_IMPORT = 'CONTENT_DOCUMENT_IMPORT';
export const CONTENT_LINK_LIST = 'CONTENT_LINK_LIST';
export const CONTENT_LINK_DETAIL = 'CONTENT_LINK_DETAIL';
export const CONTENT_LINK_EDIT = 'CONTENT_LINK_EDIT';
export const CONTENT_LINK_REGISTER = 'CONTENT_LINK_REGISTER';
export const CONTENT_LINK_IMPORT = 'CONTENT_LINK_IMPORT';
export const CONTENT_LIVE_LIST = 'CONTENT_LIVE_LIST';
export const CONTENT_LIVE_DETAIL = 'CONTENT_LIVE_DETAIL';
export const CONTENT_LIVE_EDIT = 'CONTENT_LIVE_EDIT';
export const CONTENT_LIVE_REGISTER = 'CONTENT_LIVE_REGISTER';
export const CONTENT_LIVE_IMPORT = 'CONTENT_LIVE_IMPORT';

// 添削管理
export const SCORING_REPORT_LIST = 'SCORING_REPORT_LIST'; // 取得
export const SCORING_REPORT_TOP = 'SCORING_REPORT_TOP'; // 取得
export const SCORING_REPORT_GET = 'SCORING_REPORT_GET'; // 取得
export const SCORING_REPORT_CORRECTION = 'SCORING_REPORT_CORRECTION'; // 添削
export const SCORING_REPORT_APPROVAL = 'SCORING_REPORT_APPROVAL'; // 承認
export const SCORING_REPORT_REMAND = 'SCORING_REPORT_REMAND'; // 差し戻し
export const SCORING_REPORT_COLLECTION = 'SCORING_REPORT_COLLECTION'; // 強制回収
export const SCORING_DISTRIBUTION_REPORT = 'SCORING_DISTRIBUTION_REPORT'; // レポート分配
export const SCORING_RESULT_LIST = 'SCORING_RESULT_LIST'; // 添削者別実績一覧
export const SCORING_ARCHIVEMENT_LIST = 'ARCHIVEMENT_LIST';
export const SCORING_ARCHIVEMENT_DETAIL = 'ARCHIVEMENT_DETAIL';
export const SCORING_UNSUBMITTED_LIST = 'SCORING_UNSUBMITTED_LIST'; // 未提出レポート一覧
export const SCORING_REPORT_WITHDRAWAL = 'SCORING_REPORT_WITHDRAWAL'; // 取り下げ

// 成績／実績管理画面
export const ARCHIVEMENT_STUDENT_LIST = 'ARCHIVEMENT_STUDENT_LIST'; // 受講者別成績一覧
export const ARCHIVEMENT_COURSE_LIST = 'ARCHIVEMENT_COURSE_LIST'; // コース別成績一覧
export const ARCHIVEMENT_CONTENT_USAGE_LIST = 'ARCHIVEMENT_CONTENT_USAGE_LIST'; // コンテンツ別利用実績一覧
// お知らせ管理画面
export const NOTIFICATION_LIST = 'NOTIFICATION_LIST';
export const NOTIFICATION_DETAIL = 'NOTIFICATION_DETAIL';
export const NOTIFICATION_EDIT = 'NOTIFICATION_EDIT';
export const NOTIFICATION_REGISTER = 'NOTIFICATION_REGISTER';
export const NOTIFICATION_IMPORT = 'NOTIFICATION_IMPORT';
// 利用者履歴管理画面
export const USER_HISTORY_STUDENT_LIST = 'USER_HISTORY_STUDENT_LIST'; // 履歴一覧取得
export const USER_HISTORY_STUDENT_DETAIL = 'USER_HISTORY_STUDENT_DETAIL';
export const USER_HISTORY_STUDENT_RESULT = 'USER_HISTORY_STUDENT_RESULT';
export const USER_HISTORY_COURSE_LIST = 'USER_HISTORY_COURSE_LIST';
export const USER_HISTORY_COURSE_DETAIL = 'USER_HISTORY_COURSE_DETAIL';
export const USER_HISTORY_COURSE_STUDENT_DETAIL = 'USER_HISTORY_COURSE_STUDENT_DETAIL';
export const USER_HISTORY_COURSE_STUDENT_RESULT = 'USER_HISTORY_COURSE_STUDENT_RESULT';
export const USER_HISTORY_CONTENT_LIST = 'USER_HISTORY_CONTENT_LIST';
export const USER_HISTORY_CONTENT_DETAIL = 'USER_HISTORY_CONTENT_DETAIL';
export const USER_HISTORY_LIVE_PERFORMANCE_LIST = 'USER_HISTORY_LIVE_PERFORMANCE_LIST';
export const USER_HISTORY_LIVE_PERFORMANCE_DETAIL = 'USER_HISTORY_LIVE_PERFORMANCE_DETAIL';
export const USER_HISTORY_AGGREGATE_BY_PROBLEM_DETAIL = 'USER_HISTORY_AGGREGATE_BY_PROBLEM_DETAIL'; // #7386
// 学習AI管理画面
export const LEARNING_AI_IMPORT = 'LEARNING_AI_IMPORT';
// アカウント管理画面
export const ACCOUNT_EDIT = 'ACCOUNT_EDIT'; // アカウント情報編集
export const LOGOUT = 'LOGOUT';

export const REPORT_LIST = 'REPORT_LIST';

// システム利用実績画面
export const SERVICE_RECORD_COMPANY_LIST = 'SERVICE_RECORD_COMPANY_LIST';
export const SERVICE_RECORD_SERVICE_LIST = 'SERVICE_RECORD_SERVICE_LIST';
export const SERVICE_RECORD_DOWNLOAD_FORM = 'SERVICE_RECORD_DOWNLOAD_FORM';
export const SERVICE_RECORD_SERVICES_LIST = 'SERVICE_RECORD_SERVICES_LIST'; // Step 12.3.0 TAS-21359

// message thread
export const RECEIVED_MESSAGE_LIST = 'RECEIVED_MESSAGE_LIST';
export const SENT_MESSAGE_LIST = 'SENT_MESSAGE_LIST';
export const REGISTER_MESSAGE_THREAD = 'REGISTER_MESSAGE_THREAD';
export const EDIT_MESSAGE_THREAD = 'EDIT_MESSAGE_THREAD';
export const RECEIVE_MESSAGE_THREAD_DETAIL = 'RECEIVE_MESSAGE_THREAD_DETAIL';
export const SENT_MESSAGE_THREAD_DETAIL = 'SENT_MESSAGE_THREAD_DETAIL';
export const RECEIVE_CHAT_DETAIL = 'RECEIVE_CHAT_DETAIL';
export const SENT_CHAT_DETAIL = 'SENT_CHAT_DETAIL';

// Live
export const LIVE_RESERVED_LIST = 'LIVE_RESERVED_LIST';
export const LIVE_RESERVED_DETAIL = 'LIVE_RESERVED_DETAIL';
export const LIVE_RESERVED_REGISTER = 'LIVE_RESERVED_REGISTER';
export const LIVE_RESERVED_EDIT = 'LIVE_RESERVED_EDIT';
export const PARTICIPANT_LIST = 'PARTICIPANT_LIST';
export const PARTICIPANT_DETAIL = 'PARTICIPANT_DETAIL';

// Adaptive
export const ADAPTIVE_META = 'ADAPTIVE_META';
export const DISCRIMINATION_DEGREE_DATA = 'DISCRIMINATION_DEGREE_DATA';

export const PREVIEW_EACH_QUESTION_ATTRIBUTE = 'PREVIEW_EACH_QUESTION_ATTRIBUTE';

// CSVファイルダウンロード
export const LEARNING_HISTORY_CSV_DOWNLOAD = 'LEARNING_HISTORY_CSV_DOWNLOAD';
export const PROGRESS_STATUS_CSV_DOWNLOAD = 'PROGRESS_STATUS_CSV_DOWNLOAD';

// 画面用構成ファイル管
export const DOWNLOAD_CONFIG_FILE = 'DOWNLOAD_CONFIG_FILE';
export const UPLOAD_CONFIG_FILE = 'UPLOAD_CONFIG_FILE';

// Email
export const EMAIL_LIST = 'EMAIL_LIST';
export const EMAIL_REGISTER = 'EMAIL_REGISTER';

export const RESERVED_EMAIL_LIST = 'RESERVED_EMAIL_LIST';
export const RESERVED_EMAIL_EDIT = 'RESERVED_EMAIL_EDIT';
export const RESERVED_EMAIL_DETAIL = 'RESERVED_EMAIL_DETAIL';

// 多言語表示
export const MULTI_LANGUAGE_LIST = 'MULTI_LANGUAGE_LIST';
export const MULTI_LANGUAGE_EDIT = 'MULTI_LANGUAGE_EDIT';
export const MULTI_LANGUAGE_PROCESS_RESULT_LIST = 'MULTI_LANGUAGE_PROCESS_RESULT_LIST';
export const MULTI_LANGUAGE_PROCESS_DETAIL = 'MULTI_LANGUAGE_PROCESS_DETAIL';

// 受講者画面管理
export const USERFRONT_LOGIN_SCREEN_UPDATE = 'USERFRONT_LOGIN_SCREEN_UPDATE';
export const USERFRONT_TOP_SCREEN_UPDATE = 'USERFRONT_TOP_SCREEN_UPDATE';

// パスワードリセット
export const PASSWORD_RESET = 'PASSWORD_RESET';

// 右上ダウンロード項目
export const MATERIAL_DOWNLOAD = 'MATERIAL_DOWNLOAD';

// Step 10.0.0 START
// サービスグループ設定
export const SERVICE_GROUP_LIST = 'SERVICE_GROUP_LIST';
export const SERVICE_GROUP_DETAIL = 'SERVICE_GROUP_DETAIL';
export const SERVICE_GROUP_EDIT = 'SERVICE_GROUP_EDIT';
export const SERVICE_GROUP_REGISTER = 'SERVICE_GROUP_REGISTER';
// Step 10.0.0 END
export const USER_GROUP = 'USER_GROUP';
export const CONTENT = 'CONTENT';
export const G_COMMUNICATION = 'G_COMMUNICATION';
export const G_SYSTEM = 'G_SYSTEM';

// Step 10.0.0 START
// SuperUserサービスロール設定
export const SUPERUSER_SERVICE_ROLE_LIST = 'SUPERUSER_SERVICE_ROLE_LIST';
export const SUPERUSER_SERVICE_ROLE_DETAIL = 'SUPERUSER_SERVICE_ROLE_DETAIL';
export const SUPERUSER_SERVICE_ROLE_EDIT = 'SUPERUSER_SERVICE_ROLE_EDIT';
export const SUPERUSER_SERVICE_ROLE_REGISTER = 'SUPERUSER_SERVICE_ROLE_REGISTER';

// SuperUser企業ロール設定
export const SUPERUSER_ENTERPRISE_ROLE_LIST = 'SUPERUSER_ENTERPRISE_ROLE_LIST';
export const SUPERUSER_ENTERPRISE_ROLE_DETAIL = 'SUPERUSER_ENTERPRISE_ROLE_DETAIL';
export const SUPERUSER_ENTERPRISE_ROLE_EDIT = 'SUPERUSER_ENTERPRISE_ROLE_EDIT';
export const SUPERUSER_ENTERPRISE_ROLE_REGISTER = 'SUPERUSER_ENTERPRISE_ROLE_REGISTER';

// ログイン履歴CSV出力
export const LOGIN_HISTORY_ENTERPRISE_CSV_DOWNLOAD = 'LOGIN_HISTORY_ENTERPRISE_CSV_DOWNLOAD';
export const LOGIN_HISTORY_SERVICE_CSV_DOWNLOAD = 'LOGIN_HISTORY_SERVICE_CSV_DOWNLOAD';
// Step 10.0.0 END

// Step 11.0.0 START
// 管理画面マスクステータス設定を示す
export const CONTACT = 'CONTACT';
export const FAQ = 'FAQ';
// Step 11.0.0 END

// Step 12.0.0 START
// 企業切り替え
export const ENTERPRISE_SWITCHING = 'ENTERPRISE_SWITCHING';
// コンテンツグループ
export const CONTENT_GROUP = 'CONTENT_GROUP';
// メールテンプレート設定
export const MAIL_TEMPLATE_USERS = 'メールテンプレート設定';
// Step 12.0.0 END
